// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1C9QG","footer":"ReportModalFilter_footer__32Dr2"};